import React, { useState } from 'react';

import { IChangeEvent } from '@rjsf/core';
import Form from '@rjsf/mui';
import { RJSFSchema } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';

import { Alert, Button } from '@mui/material';

import { queueBedBankBookingsReport } from '~/services/ReportingService';
import { formatDateISO, startOfMonth, subMonths } from '~/services/TimeService';

import ErrorDisplay from '../ErrorDisplay';

const formSchema: RJSFSchema = {
  description: 'Please enter your dates to export Bedbank bookings report',
  type: 'object',
  properties: {
    dateField: {
      title: 'Select the Date Field Filter',
      type: 'string',
      anyOf: [
        {
          type: 'string',
          enum: ['purchase_date'],
          title: 'Purchase Date',
        },
        {
          type: 'string',
          enum: ['check_in_date'],
          title: 'Checkin Date',
        },
      ],
    },
    startAt: {
      title: 'Select Start Date',
      type: 'string',
      format: 'date',
    },
    endAt: {
      title: 'Select End Date',
      type: 'string',
      format: 'date',
    },
    supplier: {
      title: 'Select Supplier',
      type: 'string',
      enum: [
        'All',
        'Agoda',
        'Bonotel',
        'Dida',
        'Elevate',
        'Expedia',
        'Hotelbeds',
        'Illusions',
        'Jonview',
        'MGBedbank',
        'Miki',
        'Nuitee',
        'Rakuten',
        'Stuba',
        'TBO',
        'Webbeds',
        'Yalago',
      ],
    },
  },
};

const formData = {
  startAt: formatDateISO(startOfMonth(subMonths(1))),
  endAt: formatDateISO(startOfMonth()),
  format: 'email',
  dateField: 'purchase_date',
  supplier: 'All',
};

const uiSchema = {
  dateField: {
    'ui:widget': 'radio',
  },
};

export default function ExportBedBankBookingsForm() {
  const [successMessage, setSuccessMessage] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = (event: IChangeEvent) => {
    const { startAt, endAt, format, dateField, supplier } = event.formData;

    queueBedBankBookingsReport({ startAt, endAt, format, dateField, supplier })
      .then(() => {
        setSuccessMessage(true);
      })
      .catch((err) => {
        setError(err.message);
      });
  };

  return (
    <Form
      schema={formSchema}
      uiSchema={uiSchema}
      formData={formData}
      onSubmit={handleSubmit}
      validator={validator}
      showErrorList={false}
    >
      <Button type="submit" variant="contained">
        Email Bedbank Bookings Report
      </Button>

      {error && <ErrorDisplay message={error} />}

      {successMessage && (
        <Alert severity="success">
          <p>Your report is queued for delivery and will be emailed shortly.</p>
        </Alert>
      )}
    </Form>
  );
}
